// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartProductFeeFieldset from "./CartProductFeeFieldset.res.js";

function CartProductFeesPopover(props) {
  let onRequestProductFeeRemove = props.onRequestProductFeeRemove;
  let onRequestProductFeeReplicate = props.onRequestProductFeeReplicate;
  let onRequestProductFeeUpdate = props.onRequestProductFeeUpdate;
  let popover = props.popover;
  let product = props.product;
  let match;
  if (product.TAG === "Unit") {
    let match$1 = product._0;
    match = [
      match$1.fees,
      match$1.availablesFeeKinds
    ];
  } else {
    let match$2 = product._0;
    match = [
      match$2.fees,
      match$2.availablesFeeKinds
    ];
  }
  let fees = match[0];
  let feesRef = React.useRef(fees);
  React.useEffect(() => {
    if (fees.length === 0 && fees.length < feesRef.current.length) {
      popover.close();
    }
    feesRef.current = fees;
  }, [fees]);
  if (fees.length === 0) {
    return null;
  }
  let match$3 = Stdlib_Option.map(match[1], prim => prim.length);
  return JsxRuntime.jsx(Popover.make, {
    children: JsxRuntime.jsx(Popover.Dialog.make, {
      children: JsxRuntime.jsxs(Box.make, {
        children: [
          JsxRuntime.jsx(Stack.make, {
            children: fees.map((fee, index) => JsxRuntime.jsx(CartProductFeeFieldset.make, {
              displayLabel: index === 0,
              fee: fee,
              product: product,
              onRequestProductFeeUpdate: onRequestProductFeeUpdate,
              onRequestProductFeeReplicate: onRequestProductFeeReplicate,
              onRequestProductFeeRemove: onRequestProductFeeRemove
            }, fee.id)),
            space: "normal"
          }),
          match$3 !== undefined && match$3 !== 0 ? JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(Button.make, {
                  label: I18n.t("Add costs"),
                  variant: "subtle",
                  icon: "plus_small",
                  onPress: props.onRequestProductFeeAdd
                }),
                align: "end"
              }),
              spaceTop: "normal"
            }) : null
        ],
        spaceX: "xlarge",
        spaceTop: "xlarge",
        spaceBottom: "medium"
      }),
      ariaProps: props.popoverAriaProps.overlayProps
    }),
    triggerRef: props.popoverTriggerRef,
    state: popover,
    placement: "bottom end",
    modal: false
  });
}

let make = React.memo(CartProductFeesPopover);

export {
  make,
}
/* make Not a pure module */
